
<template>
    <reveal-overlay :class="{ 'is-loading': loading }">
        <article class="pane">
            <header>
                <h1>Shoots ({{ paginator.length }})</h1>
                <router-link :to="{ name: 'admin.orders' }">Orders</router-link>
                <input class="input" placeholder="Search" v-model="query" v-on:input="search"/>
            </header>

            <table>
                <thead>
                    <tr>
                        <th><input type="checkbox" v-model="selected" v-on:change="select"/></th>
                        <th>Photoshoot</th>
                        <th>Event date</th>
                    </tr>
                </thead>
            </table>

            <div class="content">
                <table v-if="paginator.length">
                    <tbody>
                        <tr v-for="shoot in paginator.results">
                            <td><input type="checkbox" v-model="shoot.selected"/></td>
                            <td><router-link :to="{ name: 'admin.shoot', params: { id: shoot.shoot_id }, query: $route.query }">{{ shoot.title }}</router-link></td>
                            <td>{{ shoot.taken_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <footer>
                <router-link :to="{ name: 'admin.shoot.create', query: $route.query }" class="button is-primary">Create</router-link>
                <pagination :paginator="paginator"></pagination>
            </footer>
        </article>
    </reveal-overlay>
</template>

<script>
	import Paginator from '../../support/Paginator';
	import Search from '../../support/Search';
	import Shoot from '../../models/Shoot';
	import Sort from '../../support/Sort';

	export default
	{
		computed:
        {
            results()
            {
                return Search.find( this.query, this.attributes, this.sort.results );
            },
	        sort()
	        {
                return new Sort( this.records, 'title' );
	        },
            paginator()
            {
                return new Paginator( this.results, this.$route.query.page, this.$route.query.each );
            },
        },
		data()
		{
			return {
				attributes: ['title', 'location'],
				loading: false,
				records: [],
				query: this.$route.query.search || '',
				selected: false,
			};
		},
		methods:
        {
            search()
            {
                const query = { ...this.$route.query } || {},
                    search = this.query.trim();

                delete query.page;

                if( search !== '' ) {
                    query.search = search;
                } else delete query.search;

                this.$router.replace( { name: this.$route.name, query } )
            },
	        select()
            {
                for( const record of this.records )
	                record.selected = this.selected;
            },
        },
		mounted()
		{
			this.loading = true;
			Shoot.all().then( records => {
				this.records = records;
				this.loading = false;
			});
		},
	};
</script>
